import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import Login2FA from '@/components/Login2FA'
import Computers from '@/components/Computers'
import Computer from '@/components/Computer'
import Accounts from '@/components/Accounts'
//import Schedulation from '@/components/Schedulation'
import Repositories from '@/components/Repositories'
import Backup from '../components/Backup'
import PageNotFound from '../components/PageNotFound'
import Settings from '../components/Settings'
import Groups from '../components/Groups'
import Sessions from '../components/Sessions'
import ActiveSessions from '../components/ActiveSessions'
import CustomClient from '../components/CustomClient'
import Group from '../components/Group'
import Users from '../components/Users'
import Storage from '../components/Storage'
import StatsRemote from '../components/stats/StatsRemote.vue'
import StatsBackup from '../components/stats/StatsBackup.vue'
import Policies from '../components/Policies.vue'
import Licenses from '../components/Licenses.vue'
import Backups from '../components/Backups.vue'
import AuditLogs from '../components/AuditLogs.vue'
import Restores from '../components/Restores.vue'
import ScriptsInventory from '../components/ScriptsInventory.vue'
import Script from '../components/Script.vue'
import Ticket from '../components/ticketing/Ticket.vue'
import Tickets from '../components/ticketing/Tickets.vue'
import Teams from '../components/ticketing/Teams.vue'
import TeamView from '../components/ticketing/TeamView.vue'
import Customers from '../components/ticketing/Customers.vue'
import Invoices from '../components/ticketing/Invoices.vue'
import ExpiredLicence from '../components/ExpiredLicence.vue'
import ScriptDeployHistory from '../components/ScriptDeployHistory.vue'

Vue.use(VueRouter)

function getSavedAuth() {
    try {
        const auth = localStorage.getItem("AUTH");
        return auth ? JSON.parse(auth) : null;
    } catch (_) {
        return null;
    }
}

function isLicenceExpired() {
    const auth = getSavedAuth();
    return auth != null && auth.licenceExpired == true;
}

const router = new VueRouter({
    //history: createWebHistory(),

    linkExactActiveClass: "",
    routes: [{
            path: '/',
            name: 'login',
            //component: () =>
            //    import ('../components/Login.vue'),
            component: Login,
            meta: {
                title: 'Login',
                keepAlive: false, //keepAlive: true,
                skipSocket: true
            }
        },
        {
            path: '/login2FA',
            name: 'login2FA',
            component: Login2FA,
            meta: {
                title: 'Login 2FA',
                keepAlive: false, //keepAlive: true,
                skipSocket: true
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                title: 'Dashboard',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/storage',
            name: 'Storage Accounts',
            component: Storage,
            meta: {
                title: 'Storage',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/computers',
            name: 'Computers',
            component: Computers,
            props: true,
            meta: {
                title: 'Computers',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/computers/computer/:idPC',
            name: 'Computer',
            component: Computer,
            props: true,
            meta: {
                title: 'Computer Details',
                keepAlive: false, //keepAlive: true
            }
            /*beforeEnter(to, from, next) {
                if (this.$store.state.accessToken) {
                    this.$store.dispatch('setInternalComponents', true);
                    next()
                } else
                    next('/')
            }*/
        },
        {
            path: '/computers/computer/:idPC/backup',
            name: 'Create new backup',
            component: Backup,
            props: true,
            meta: {
                title: 'Backup',
                keepAlive: false, //keepAlive: true
            }
            /*beforeEnter(to, from, next) {
                if (this.$store.state.accessToken) {
                    this.$store.dispatch('setInternalComponents', true);
                    next()
                } else
                    next('/')
            }*/
        },
        {
            path: '/computers/computer/:idPC/backup/:idBackup',
            name: 'Edit backup',
            component: Backup,
            props: true,
            meta: {
                title: 'Backup',
                keepAlive: false, //keepAlive: true
            }
            /*beforeEnter(to, from, next) {
                if (this.$store.state.accessToken) {
                    this.$store.dispatch('setInternalComponents', true);
                    next()
                } else
                    next('/')
            }*/
        },
        // {
        //     path: '/computer/:idPC',
        //     name: 'computer',
        //     component: Computer,
        //     props: true,
        //       meta: {
        //           title: 'Computer Details',
        //         keepAlive: false, //keepAlive: true
        //     }
        //     /*beforeEnter(to, from, next) {
        //         if (this.$store.state.accessToken) {
        //             this.$store.dispatch('setInternalComponents', true);
        //             next()
        //         } else
        //             next('/')
        //     }*/
        // },

        // {
        //     path: '/computer/:idPC/backup',
        //     name: 'backupView',
        //     component: Backup,
        //     props: true,
        //       meta: {
        //           title: 'Backup',
        //         keepAlive: false, //keepAlive: true
        //     }
        //     /*beforeEnter(to, from, next) {
        //         if (this.$store.state.accessToken) {
        //             this.$store.dispatch('setInternalComponents', true);
        //             next()
        //         } else
        //             next('/')
        //     }*/
        // },

        // {
        //     path: '/backup',
        //     name: 'backup',
        //     component: Backup,
        //     props: true,
        //       meta: {
        //           title: 'Backup',
        //         keepAlive: false, //keepAlive: true
        //     }
        // },
        // {
        //     path: '/backup/:idBackup',
        //     name: 'backupEdit',
        //     component: Backup,
        //     props: true,
        //       meta: {
        //           title: 'Backup Edit',
        //         keepAlive: false, //keepAlive: true
        //     }
        // },
        {
            path: '/accounts',
            name: 'Accounts',
            component: Accounts,
            props: true,
            meta: {
                title: 'Accounts',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/repo',
            name: 'Repositories',
            component: Repositories,
            props: true,
            meta: {
                title: 'Repositories',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/settings',
            name: 'Settings',
            component: Settings,
            props: true,
            meta: {
                title: 'Settings',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/groups',
            name: 'Groups',
            component: Groups,
            props: true,
            meta: {
                title: 'Groups',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/groups/:idGroup',
            name: 'Group Details',
            component: Groups,
            props: true,
            meta: {
                title: 'Group Details',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/policies',
            name: 'Policies',
            component: Policies,
            props: true,
            meta: {
                title: 'Policies',
                keepAlive: false, //keepAlive: true
            }
        },

        {
            path: '/group/:idGroup',
            name: 'group',
            component: Group,
            props: true,
            meta: {
                title: 'Group Details',
                keepAlive: false, //keepAlive: true
            }
        },
/*         {
            path: '/scheduling',
            name: 'scheduling',
            component: Schedulation,
            props: false,
            meta: {
                title: 'Schedulings',
                keepAlive: false, //keepAlive: true
            }

        },
        {
            path: '/scheduling/:idbackup',
            name: 'schedulingDetail',
            component: Schedulation,
            props: true,
            meta: {
                title: 'Scheduling Detail',
                keepAlive: false, //keepAlive: true
            }
        }, */
        {
            path: '/users',
            name: 'users',
            component: Users,
            props: true,
            meta: {
                title: 'Users',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/sessions',
            name: 'sessions',
            component: Sessions,
            props: true,
            meta: {
                title: 'Sessions',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/backups',
            name: 'backups',
            component: Backups,
            props: true,
            meta: {
                title: 'Backups',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/restores',
            name: 'restores',
            component: Restores,
            props: true,
            meta: {
                title: 'Restores',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/activesessions',
            name: 'activesessions',
            component: ActiveSessions,
            props: true,
            meta: {
                title: 'Active Sessions',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/remotestats',
            name: 'remotestats',
            component: StatsRemote,
            meta: {
                title: 'Remote Stats',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/customclient',
            name: 'customclient',
            component: CustomClient,
            props: true,
            meta: {
                title: 'Custom client',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/backupstats',
            name: 'backupstats',
            component: StatsBackup,
            meta: {
                title: 'Backup Stats',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/licenses',
            name: 'licenses',
            component: Licenses,
            meta: {
                title: 'Licenses',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/auditlogs',
            name: 'auditLogs',
            component: AuditLogs,
            meta: {
                title: 'Audit logs',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path:"/scripts",
            redirect:'/scripts/inventory'
        },
        {
            path: '/scripts/inventory',
            name: 'scriptsinventory',
            component: ScriptsInventory,
            meta: {
                title: 'Scripts Inventory',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/scripts/history',
            name: 'scriptshistory',
            component: ScriptDeployHistory,
            meta: {
                title: 'Deploy history',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/scripts/new',
            name: 'scriptnew',
            component: Script,
            meta: {
                title: 'Create New Script',
                keepAlive: false,
            }
        },
        {
            path: '/scripts/:idScript',
            name: 'script',
            component: Script,
            props: true,
            meta: {
                title: 'Script',
                keepAlive: false,
            }
        },
        {
            path: '/tickets',
            name: 'tickets',
            component: Tickets,
            meta: {
                title: 'Tickets',
                keepAlive: false,
            }
        },
        {
            path: '/ticket/:idTicket?',
            name: 'ticket',
            component: Ticket,
            props: true,
            meta: {
                title: 'Ticket',
                keepAlive: false,
            }
        },
        {
            path: '/teams',
            name: 'teams',
            component: Teams,
            meta: {
                title: 'Teams',
                keepAlive: false,
            }
        },
        {
            path: '/teams/:idTeam',
            name: 'team-view',
            component: TeamView,
            props: true,
            meta: {
                title: 'Team Details',
                keepAlive: false,
            }
        },
        {
            path: '/billing/clients',
            name: 'customers',
            component: Customers,
            meta: {
                title: 'Customers',
                keepAlive: false,
            }
        },
        {
            path: '/billing/invoices',
            name: 'invoices',
            component: Invoices,
            meta: {
                title: 'Invoices',
                keepAlive: false,
            }
        },
         {
            path: '/expiredlicence',
            name: 'expiredlicence',
            component: ExpiredLicence,
            meta: {
                title: 'Expired licence',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: '/404',
            name: 'PageNotExist',
            component: PageNotFound,
            meta: {
                title: 'Page Not Found',
                keepAlive: false, //keepAlive: true
            }
        },
        {
            path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
            redirect: '/404',
        },

    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            try {
                document.querySelector(to.hash);
                return {
                    selector: to.hash
                };
            } catch (_) {
                // Alcuni hash sono usati come payload applicativo, non come selector DOM.
            }
        }
        return { x: 0, y: 0 };
    },
    mode: "history",
    base: process.env.BASE_URL,
    //mode:'history' //https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
})

window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true;
})

router.beforeEach((to, from, next) => {
    console.debug(`Navigato da ${from.path} a ${to.path}`);

    // Punto d'ingresso sicuro per i PC aperti in una nuova scheda/finestra.
    // La root viene sempre servita anche quando il server di produzione non è
    // configurato con il fallback delle route del router in history mode.
    if (to.name === 'login' && to.query.openPC) {
        next({
            name: 'Computer',
            params: { idPC: to.query.openPC }
        });
        return;
    }

    sessionStorage.setItem('lastRoute', to.fullPath);

    if (isLicenceExpired() && to.path != '/expiredlicence') {
        next('/expiredlicence');
        return;
    }

    if (to.hash) {
        console.debug('Hash rilevato nel router:', to.hash);
        console.debug('Url nel router:', to.path);

        // TODO: sarebbe da mettere qui tutta la logica per aprire le dialog di tutte le pagine evitando di metterla dentro un
        //watccher di ogni pagina....
    } else {
        console.debug('Nessun hash rilevato nel router');
        // Logica per chiudere una dialog o eseguire un'altra azione
        //posso fare un controllo che chiude la dialog se ce ne sta una aperta e l'url non ha hastag..
        //faccio quella delle policy per esempio ma si potrebbe invocare un metodo generico che in base alla pagina aperta chiude 
        //la specifica dialog SE aperta
    }
    if (to.meta.styles) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = to.meta.styles;
        document.head.appendChild(link);
    }
    const IsItABackButton = window.popStateDetected;
    window.popStateDetected = false;
    next();
})

router.afterEach((to, from) => {
});

/* router.beforeResolve(to => {
    return to.fullPath;
}) */

export default router;
